import { useState, useCallback } from 'react';

// 설정 값
const SOTERIA_URL = 'https://imch-youth-soteria.vercel.app';
const API_SECRET = 'soteria_admin_connect_secret_2026';

export const useSoteriaAttendance = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getSoteriaAttendees = useCallback(async (dateString) => {
        setLoading(true);
        setError(null);
        try {
            const targetDate = dateString || new Date().toISOString().split('T')[0];

            const response = await fetch(`${SOTERIA_URL}/api/external/attendance?date=${targetDate}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-soteria-secret': API_SECRET
                }
            });

            if (!response.ok) throw new Error('데이터 불러오기 실패');

            const data = await response.json();
            return data.attendees || [];
        } catch (err) {
            console.error('SOTERIA Sync Error:', err);
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return { getSoteriaAttendees, loading, error };
};
